import axios from 'axios';
import http from '@/utils/http';

import config from '@/config';

export const apiGetMessages = async (addressId) => {
  const endpoint = `${config.apiUrl}userapi/integrations/tenant-integration/messages?externalId=${addressId}`;
  const response = await http.get(endpoint);

  return response.data;
};

export const apiGetSyncMessages = async (externalId) => {
  const response = await axios.get(`${config.syncApiUrl}userapi/notify/${externalId}`);
  return response.data;
};
